import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { BaseStepLayout } from '../BaseStepLayout'
import { StepNavigation } from '../StepNavigation'
import { defaultStepFormProps } from '../types.d'
import CaptureGMSForm from './CaptureGMSForm'
import { CaptureGMSFields } from './CaptureGMSFields'
import { useFindGMSWithNonOption, useGetExternalGMS } from 'app/auth/components/hooks/use-external-gms'
import { useApplicationName } from 'hooks/use-application-name'
import { WithRunInBackgroundHelper } from '../use-should-run-in-background'

export const CaptureGMSSelection: React.FC<
  defaultStepFormProps<{ ExternalGMSUUID: string; Remark: string }> & {
    onSubmit: (values: any) => void
  }
> = ({ onSubmit, isFirstStep, isPersisting, onSubmitSuccess, hideSkip, prevStep, shouldRunInBackground, initialData }) => {
  const externalGMSQueryResult = useGetExternalGMS()
  const defaultOption = useFindGMSWithNonOption(externalGMSQueryResult.data || [])
  const initialValues = useMemo(
    () => ({
      UUID: initialData.ExternalGMSUUID || defaultOption?.UUID || '',
      HasRemark: initialData.Remark ? true : defaultOption?.HasRemark || false,
      Name: initialData.Remark || defaultOption?.Name || ''
    }),
    [defaultOption, initialData]
  )
  const { t } = useTranslation()
  const { appName } = useApplicationName()

  return (
    <BaseStepLayout
      title={t('onboarding.capture_gms_information_form.step_header')}
      subTitles={[t('onboarding.capture_gms_information_form.step_subtitleWithAppName', { appName })]}
    >
      <CaptureGMSForm onSubmit={onSubmit} onSubmitSuccess={onSubmitSuccess} initialValues={initialValues} enableReinitialize>
        {formikProps => (
          <WithRunInBackgroundHelper
            enabled={shouldRunInBackground}
            isSubmitting={formikProps.isSubmitting}
            onSubmit={formikProps.handleSubmit}
          >
            <CaptureGMSFields
              formikProps={formikProps}
              externalGMSList={externalGMSQueryResult.data || []}
              isLoading={externalGMSQueryResult.isLoading}
            />
            <StepNavigation
              prevStep={prevStep}
              hideBack={isFirstStep}
              disableNext={formikProps.values.UUID === ''}
              isLoading={formikProps.isSubmitting || isPersisting}
              hideSkip={hideSkip}
            />
          </WithRunInBackgroundHelper>
        )}
      </CaptureGMSForm>
    </BaseStepLayout>
  )
}

export default CaptureGMSSelection
